import Action from '../action/action';
import ActionDto from '../action/action-dto';
import ArrayHelper from '@vertical-plus/vue-js-core/dist/util/content/array-helper';
import ConditionValidator from '../../../validator/mapping-tool/condition-validator';
import Rule from '../rule/rule';
export default class Condition {
    constructor(dto) {
        this.dto = Object.assign({}, dto);
    }
    get id() {
        return this.dto.id;
    }
    set id(id) {
        this.dto.id = id;
    }
    get rule() {
        if (!this.dto.rule) {
            return null;
        }
        return new Rule(this.dto.rule);
    }
    set rule(rule) {
        if (rule) {
            this.dto.rule = rule.dto;
        }
        else {
            this.dto.rule = null;
        }
    }
    get valueSettings() {
        return this.dto.valueSettings;
    }
    set valueSettings(valueSettings) {
        this.dto.valueSettings = valueSettings;
    }
    get operator() {
        return this.dto.operator;
    }
    set operator(operator) {
        this.dto.operator = operator;
    }
    get expectedValueSettings() {
        return this.dto.expectedValueSettings;
    }
    set expectedValueSettings(expectedValueSettings) {
        this.dto.expectedValueSettings = expectedValueSettings;
    }
    get position() {
        return this.dto.position;
    }
    set position(position) {
        this.dto.position = position;
    }
    get actions() {
        const actions = [];
        for (const actionDto of this.dto.actions) {
            actions.push(new Action(actionDto));
        }
        return actions;
    }
    set actions(actions) {
        this.dto.actions = [];
        for (const action of actions) {
            this.dto.actions.push(action.dto);
        }
    }
    addAction(action) {
        this.dto.actions.push(action.dto);
        this.setActionPositions();
    }
    updateAction(action, key) {
        this.dto.actions.splice(key, 1, action.dto);
    }
    removeAction(key) {
        this.dto.actions.splice(key, 1);
    }
    moveAction(fromIndex, toIndex) {
        // Make sure the indexes are valid
        if (typeof this.dto.actions[fromIndex] === 'undefined' || typeof this.dto.actions[toIndex] === 'undefined') {
            return;
        }
        // Move the action
        ArrayHelper.move(this.dto.actions, fromIndex, toIndex);
        // Reset the position values
        this.setActionPositions();
    }
    setActionPositions() {
        for (const key in this.dto.actions) {
            this.dto.actions[key].position = parseInt(key) + 1;
        }
    }
    /**
     * Return the parameters to create/update this condition
     * @returns ConditionParamsInterface
     */
    get params() {
        const params = {
            valueSettings: this.valueSettings,
            operator: this.operator,
            expectedValueSettings: this.expectedValueSettings,
            position: this.position,
            actions: [],
        };
        for (const action of this.actions) {
            params.actions.push(action.params);
        }
        return params;
    }
    addBlankAction() {
        const action = new Action(new ActionDto());
        action.condition = this;
        action.type = 'take';
        action.valueSettings = {
            valueColumn: '',
        };
        this.addAction(action);
    }
    hasValue() {
        return this.valueSettingsHasValue(this.valueSettings);
    }
    hasExpectedValue() {
        return this.valueSettingsHasValue(this.expectedValueSettings);
    }
    valueSettingsHasValue(valueSettings) {
        if (!valueSettings) {
            return false;
        }
        let value = null;
        switch (true) {
            case ('value' in valueSettings):
                value = valueSettings.value;
                break;
            case ('valueRuleId' in valueSettings):
                value = valueSettings.valueRuleId;
                break;
            case ('valueColumn' in valueSettings):
                value = valueSettings.valueColumn;
                break;
        }
        if (value === null) {
            return false;
        }
        return true;
    }
    /**
     * Return the object to validate this entity
     *
     * @returns ConditionValidator
     */
    get validator() {
        return new ConditionValidator();
    }
    /**
     * Returns the validation errors from the form
     */
    get validationErrors() {
        return this.validator.validate(this);
    }
    /**
     * Returns whether the form is valid
     */
    get valid() {
        return Object.keys(this.validationErrors).length === 0;
    }
}
//# sourceMappingURL=condition.js.map